export const RESTRICTED_OFFLINE_VENDOR_ID = 172355;

export const isOfflineOrderStatusLockEnabled = (order) =>
  Number(order?.product_vendor_id) === RESTRICTED_OFFLINE_VENDOR_ID;

export const getOfflineOrderStatusOwner = (order) => {
  const tracking = order?.order_status_tracking || [];
  const ownerEntry = tracking.find(
    (item) => item?.user_id && Number(item.user_id) > 0,
  );

  if (!ownerEntry) {
    return null;
  }

  return {
    userId: Number(ownerEntry.user_id),
    userName: ownerEntry.full_name || '',
  };
};

export const getOfflineOrderStatusLockMessage = (owner) => {
  const userLabel = owner?.userName || 'another team member';
  return `This order is assigned to ${userLabel}. Only the user who updated its status can make further status changes.`;
};

export const canChangeOfflineOrderStatus = (order, currentUserId) => {
  if (!isOfflineOrderStatusLockEnabled(order)) {
    return { allowed: true };
  }

  const owner = getOfflineOrderStatusOwner(order);
  if (!owner) {
    return { allowed: true };
  }

  if (Number(currentUserId) === owner.userId) {
    return { allowed: true };
  }

  return {
    allowed: false,
    owner,
    message: getOfflineOrderStatusLockMessage(owner),
  };
};
